import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
    selector: 'app-careers',
    templateUrl: './careers.component.html',
    styleUrls: ['./careers.component.scss'],
    standalone: false
})
export class CareersComponent implements OnInit 
{

  constructor(
    public translateService: TranslateService
  ) 
  { 

  }

  ngOnInit() 
  {
  }

}
